export interface SupabaseAuthEnv {
  url: string;
  publishableKey: string;
  /** Isolate persisted sessions between Auth projects. */
  storageKey: string;
}

/** Auth is a single Singapore project; business APIs remain regional. */
export const supabaseAuthProd: SupabaseAuthEnv = Object.freeze({
  url: 'https://bxoujxvtejswxowvjmvn.supabase.co',
  publishableKey: 'sb_publishable_5v2-ukUZxw7vA6cMzVxk2g_oFc_dVyT',
  storageKey: 'web-isp-supabase-auth-prod',
});

export const supabaseAuthDev: SupabaseAuthEnv = Object.freeze({
  url: 'https://axjbybjabmkyqehvrijj.supabase.co',
  publishableKey: 'sb_publishable_eVN8Kppb69dk8Ml6oXHPTw_xLEFAvGh',
  storageKey: 'web-isp-supabase-auth-dev',
});

export type AccountOAuthEnvKey = 'prod' | 'dev';

export interface AccountOAuthConfig {
  accountAppUrl: string;
  oauthClientId: string;
}

/** DEV/LOCAL → mp-dev Auth (+ local/dev mp-auth); US/EU/CN → mp-prod Auth. */
export function isDevAuthRegion(regionCode: string): boolean {
  return regionCode === 'DEV' || regionCode === 'LOCAL';
}

/**
 * DEV/LOCAL → mp-dev Auth; US/EU/CN → mp-prod Auth.
 * Must stay paired with RegionService API resolution.
 */
export function resolveSupabaseAuthEnv(regionCode: string): SupabaseAuthEnv {
  return isDevAuthRegion(regionCode) ? supabaseAuthDev : supabaseAuthProd;
}

/** Same Auth project ⇒ access_token is reusable across business API regions. */
export function isSameSupabaseAuthEnv(fromRegion: string, toRegion: string): boolean {
  return resolveSupabaseAuthEnv(fromRegion).storageKey === resolveSupabaseAuthEnv(toRegion).storageKey;
}

/** Pair mp-auth origin + OAuth client with the Auth project for this region. */
export function accountOAuthEnvKey(regionCode: string): AccountOAuthEnvKey {
  return isDevAuthRegion(regionCode) ? 'dev' : 'prod';
}
